// Appointment windows the clinic offers — patients pick one when booking, admins can reassign it later
const TIME_SLOTS = ['08:00 AM', '09:30 AM', '11:00 AM', '01:00 PM', '02:30 PM', '04:00 PM'];

export default TIME_SLOTS;
